<section class="main-content">
  <div class="section-body">
    <div class="row mt-3">
      <div class="col-12">
        <div class="card card-cm-dashboard w-100">
          <div class="card-header">
            <div class="row">
              <div class="col-10">
                <h4 class="text-primary">City Manager Dashboard</h4>
              </div>
              <div class="col-2 text-right">
                <!-- <tui-combo-box class="b-form" [formControl]="selectedCityValue"
                  [stringify]="STRINGIFY_DROPDOWN_DISPLAY_CITY" tuiTextfieldSize="s"
                  [tuiTextfieldCleaner]="true">
                  City
                  <input placeholder="Type a City" tuiTextfieldLegacy appSelectTextOnFocus />
                  <tui-data-list-wrapper *tuiDataList
                    [itemContent]="STRINGIFY_DROPDOWN_DISPLAY_CITY | tuiStringifyContent"
                  [items]="cityListForJobPlanning | tuiFilterByInput"></tui-data-list-wrapper>
                </tui-combo-box> -->
                <tui-textfield tuiChevron [tuiTextfieldCleaner]="true" tuiTextfieldSize="m" class="b-form"
                  [stringify]="STRINGIFY_DROPDOWN_DISPLAY_CITY">
                  <label tuiLabel>City</label>
                  <input tuiComboBox [formControl]="selectedCityValue" placeholder="Type a City" appSelectTextOnFocus />
                  <tui-data-list-wrapper *tuiDropdown new [items]="cityListForJobPlanning | tuiFilterByInput"
                    [itemContent]="STRINGIFY_DROPDOWN_DISPLAY_CITY | tuiStringifyContent" />
                </tui-textfield>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <div class="card w-100">
                  @if (todayCardLoading) {
                  <div class="loading-overlay">
                    <div class="spinner-border text-primary spinner-lg"></div>
                  </div>
                  }
                  <div class="card-header text-primary">Today</div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goTodaysTileView()">
                          <div class="card-header text-secondary  text-small-x lh-11"># of
                            Venues</div>
                          <div class="card-body text-center">
                            <h4 class="text-secondary">
                              {{todaysCMDashboardInfo?.venuesActiveTodayCount}}</h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goTodaysTileView()">
                          <div class="card-header text-secondary  text-small-x lh-11"># of
                            Jobs</div>
                          <div class="card-body text-center">
                            <h4 class="text-secondary">{{todaysCMDashboardInfo?.noOfJobs}}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goTodaysTileView()">
                          <div class="card-header text-secondary  text-small-x lh-11">#
                            Laborers working</div>
                          <div class="card-body text-center p-3">
                            <div class="badge badge-light p-1">
                              Scp - <span class="text-primary">{{todaysCMDashboardInfo?.noOfLaborsScoped}}</span>
                            </div>
                            <div class="badge badge-light p-1 ms-1">
                              Act - <span class="text-success">{{todaysCMDashboardInfo?.noOfLaborsActual}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="card w-100">
                  @if (thisWeekPayrollCardLoading) {
                  <div class="loading-overlay">
                    <div class="spinner-border text-primary spinner-lg"></div>
                  </div>
                  }
                  <div class="card-header text-primary"
                    [ngClass]="{'bg-success':$safeNavigationMigration(payrollWeeksData?.isSubmittedAllPayrollThisWeek)}">
                    This
                    Week's Payroll</div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToPayrollEntry('unsubmitted')">
                          <div class="card-header text-secondary  text-small-x lh-11">Payroll
                            Unsubmitted</div>
                          <div class="card-body text-center">
                            <h4 class="text-primary">
                              {{ payrollWeeksData?.payrollDueCount }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToPayrollEntry('NO_FILTER')">
                          <div class="card-header text-secondary  text-small-x lh-11">Payrolls
                            Submitted</div>
                          <div class="card-body text-center">
                            <h4 class="text-success">
                              {{ payrollWeeksData?.payrollSubmittedCount }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToPayrollEntry('unbillhrs')">
                          <div class="card-header text-secondary  text-small-x lh-11">Unbilled
                            Hours</div>
                          <div class="card-body text-center">
                            <h4 class="text-secondary">
                              {{ payrollWeeksData?.unbillHours }}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="card w-100">
                  @if (dailyReportCardLoading) {
                  <div class="loading-overlay">
                    <div class="spinner-border text-primary spinner-lg"></div>
                  </div>
                  }
                  <div class="card-header text-primary" [ngClass]="{'bg-success':$safeNavigationMigration(dailyReportData?.isCompletedFromYesterday),
                                  'bg-error':getIsNotComplted(dailyReportData)}">Daily Report</div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToDailyActivity(true, 'INC')">
                          <div class="card-header text-secondary  text-small-x lh-11">
                            Incomplete Yesterday</div>
                          <div class="card-body text-center">
                            <h4 class="text-warning">{{ dailyReportData?.yesterdayDueCount
                              }}</h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToDailyActivity(false, 'DUE')">
                          <div class="card-header text-secondary  text-small-x lh-11">Due
                            Today</div>
                          <div class="card-body text-center">
                            <h4 class="text-primary">{{ dailyReportData?.todayDueCount }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToDailyActivity(false, 'SUBM')">
                          <div class="card-header text-secondary  text-small-x lh-11">
                            Submitted</div>
                          <div class="card-body text-center">
                            <h4 class="text-success">{{ dailyReportData?.todaySubmittedCount
                              }}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="card w-100">
                  @if (billingEntryCardLoading) {
                  <div class="loading-overlay">
                    <div class="spinner-border text-primary spinner-lg"></div>
                  </div>
                  }
                  <div class="card-header text-primary">Billing</div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToBillingEntry()">
                          <div class="card-header text-secondary text-small-x lh-11">
                            Unsubmitted Shows <br>past due</div>
                          <div class="card-body text-center">
                            <h4 class="text-warning">
                              {{ billingEntryDataForDashboard?.unSubmittedShowsPastDue}}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToBillingEntry()">
                          <div class="card-header text-secondary text-small-x lh-11">Shows due
                            <br>this Week
                          </div>
                          <div class="card-body text-center">
                            <h4 class="text-danger">
                              {{ billingEntryDataForDashboard?.showsDueThisWeek}}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer" (click)="goToBillingEntry()">
                          <div class="card-header text-secondary text-small-x lh-11">Shows
                            submitted <br>this week</div>
                          <div class="card-body text-center">
                            <h4 class="success-color">
                              {{ billingEntryDataForDashboard?.showsSubmittedThisWeek}}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="card w-100">
                  @if (jobOverrunCardLoading) {
                  <div class="loading-overlay">
                    <div class="spinner-border text-primary spinner-lg"></div>
                  </div>
                  }
                  <div class="card-header text-primary">Jobs Running Over - ( Total: <span
                      class="primary-color">{{overRunJobCount?.totalJobs}}</span> )
                    <!-- <span *ngIf="isLoadingOverrunJobData" class="spinner-border spinner-border-sm margin-left-10"></span> -->
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6">
                        <div class="card w-100 cursor-pointer" (click)="gotToJobOverOnUnderBudget('on')">
                          <div class="card-header text-secondary text-small-x lh-11"># of
                            Active Jobs<br> on Budget</div>
                          <div class="card-body text-center">
                            <h4 class="text-secondary">
                              {{ overRunJobCount?.activeJobsOnBudget }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card w-100 cursor-pointer" (click)="gotToJobOverOnUnderBudget('over')">
                          <div class="card-header text-secondary text-small-x lh-11"># of
                            Active Jobs <br>over Budget</div>
                          <div class="card-body text-center">
                            <h4 class="text-danger">
                              {{ overRunJobCount?.activeJobsOverBudget }}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-4">
                          <div class="card w-100 cursor-pointer"
                            (click)="gotToJobOverOnUnderBudget('under')">
                            <div class="card-header text-secondary text-small-x lh-11"># of
                              Active Jobs <br>under Budget</div>
                              <div class="card-body text-center">
                                <h4 class="text-success">
                                  {{ overRunJobCount?.activeJobsUnderBudget }}
                                </h4>
                              </div>
                            </div>
                          </div> -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="card w-100">
                  @if (importantJobCardLoading) {
                  <div class="loading-overlay">
                    <div class="spinner-border text-primary spinner-lg"></div>
                  </div>
                  }
                  <div class="card-header text-primary">
                    Important Job Updates
                    <i class="pad-left-10 cursor-pointer  warning-color" (click)="importantJobUpdatesClear()"
                      style="text-decoration: underline;">
                      Clear Update
                    </i>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer">
                          <div class="card-header text-secondary text-small-x lh-11">New Jobs
                            <br> Added Today
                          </div>
                          <div class="card-body text-center">
                            <h4 class="text-primary cursor-pointer"
                              (click)="openImportantJobDialog(importantJobUpdateInfo.noOfJobSoList)">
                              {{importantJobUpdateInfo?.noOfJobAdded}}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100 cursor-pointer">
                          <div class="card-header text-secondary text-small-x lh-11">Labor
                            updates
                            <br> on Active Jobs
                          </div>
                          <div class="card-body text-center">
                            <h4 class="text-primary cursor-pointer"
                              (click)="openImportantJobDialog(importantJobUpdateInfo.laborUpdateSoList)">
                              {{importantJobUpdateInfo?.laborUpdateOnActiveJobs}}</h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card w-100">
                          <div class="card-header text-secondary text-small-x lh-11">Shipping
                            updates
                            <br> on Active Jobs
                          </div>
                          <div class="card-body text-center">
                            <h4 class="text-primary cursor-pointer"
                              (click)="openImportantJobDialog(importantJobUpdateInfo.shippingUpdateSoList)">
                              {{importantJobUpdateInfo?.shippingUpdateOnActiveJobs}}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="card text-center">
          <div class="card-header">
            <h5 class="text-center-m-0-auto text-primary p-2">Quick Links</h5>
          </div>
          <div class="card-body p-4">
            <div class="row">
              @if (getJobPlanningAccess()) {
              <div class="col-3">
                <div (click)="goToCalenderView()" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Calendar View
                  </div>
                </div>
              </div>
              }
              @if (getJobPlanningAccess()) {
              <div class="col-3">
                <div (click)="goToLaborCheckIn()" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Check-In
                  </div>
                </div>
              </div>
              }
              @if (getPayrollEntryAddUpdateAccess()) {
              <div class="col-3">
                <div (click)="goToPayrollEntry('NO_FILTER')" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Payroll Entry
                  </div>
                </div>
              </div>
              }
              @if (getPayrollEntryReportAccess()) {
              <div class="col-3">
                <div (click)="goToPayrollEntryReport()" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Payroll Entry Report
                  </div>
                </div>
              </div>
              }
              @if (getPayrollEntrySnapshotAccess()) {
              <div class="col-3">
                <div (click)="goToPayrollEntrySnapshot()" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Payroll Entry Snapshot
                  </div>
                </div>
              </div>
              }
              @if (getBillingEntryAddUpdateAccess()) {
              <div class="col-3">
                <div (click)="goToBillingEntry()" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Billing Entry
                  </div>
                </div>
              </div>
              }
              @if (getBillingEntryReportAccess()) {
              <div class="col-3">
                <div (click)="goToBillingEntryReport()" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Billing Entry Report
                  </div>
                </div>
              </div>
              }
              @if (getDailyActivityAccess()) {
              <div class="col-3">
                <div (click)="goToDailyActivity(false, '')" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Daily Activity
                  </div>
                </div>
              </div>
              }
              @if (getPayrollEntryAddUpdateAccess()) {
              <div class="col-3">
                <div (click)="openPayrollCorrectionReqApprovedDialog()" class="card cursor-pointer">
                  <div class="card-body p-2 text-primary">
                    Payroll Correction Approval Requests
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<ng-template [tuiDialogOptions]="{ closable: false, size: 'm', dismissible: false}"
  [(tuiDialog)]="isOpenImportantJobDialog">
  <tui-loader class="loader" [inheritColor]="isLoadingImportantJobDialog" [overlay]="isLoadingImportantJobDialog"
    [loading]="isLoadingImportantJobDialog">
    <header class="header">
      <div class="col-12">
        <div class="title-flex">
          <h4 class="main-title">
            <span tuiAvatar="@tui.credit-card" class="taga-icons"></span>
            <span class="mt-1 pad-left-10"> Service Orders - Updates </span>
          </h4>
          <div class="text-end-container">
            <button iconStart="@tui.x" class="margin-left-10" appearance="outline" tuiIconButton
              (click)="closeImportantJobDialog()" type="button" size="s" placement="right"></button>
          </div>
        </div>
      </div>
    </header>
    <div class="dialog-content">
      <hr class="title-line mt-1 mb-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="table-responsive-sm">
            <table class="table table-sm table-border">
              <thead class="table-light">
                <tr>
                  <td style="width: 30%;">
                    Show Name
                  </td>
                  <td style="width: 50%;">
                    Exhibitor Name
                  </td>
                  <td style="width: 20%;">
                    SO
                  </td>
                </tr>
              </thead>
              <tbody>
                @for (item of selectedNoOfJobList; track item) {
                <tr>
                  <td>
                    {{item.showName}}
                    @if (item.showTags) {
                    <div>
                      ({{item.showTags}})
                    </div>
                    }
                  </td>
                  <td>
                    {{item.clientName}}
                  </td>
                  <td>
                    <a (click)="openPreviewSO(item.serviceOrderId)" class="cursor-pointer primary-color">
                      {{item.serviceOrderFullNumber}}
                    </a>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </tui-loader>
</ng-template>


<ng-template [tuiDialogOptions]="{ closable: false, size: 'l', dismissible: false}"
  [(tuiDialog)]="isOpenPayrollCorrectioknReqApprovedDialog">
  <tui-loader class="loader" [inheritColor]="isLoadingPayrollCorrectioknReqApprovedDialog"
    [overlay]="isLoadingPayrollCorrectioknReqApprovedDialog" [loading]="isLoadingPayrollCorrectioknReqApprovedDialog">
    <header class="header">
      <div class="col-12">
        <div class="title-flex">
          <h4 class="main-title">
            <span tuiAvatar="@tui.credit-card" class="taga-icons"></span>
            <span class="mt-1 pad-left-10">Last Week Payroll Correction Requests </span>
          </h4>
          <div class="text-end-container">
            <button iconStart="@tui.x" class="margin-left-10" appearance="outline" tuiIconButton
              (click)="closePayrollCorrectionReqApprovedDialog()" type="button" size="s" placement="right"></button>
          </div>
        </div>
      </div>
    </header>
    <div class="dialog-content" style="min-width: 1400px;">
      <hr class="title-line mt-1 mb-2">
      @if (cmPayrollCorrectionRequestApprovedList.length === 0) {
      <div class="alert alert-outline mt-2" role="alert">
        <div class="warning-color">
          No Request Available!
        </div>
      </div>
      }
      @if (cmPayrollCorrectionRequestApprovedList.length > 0) {
      <div class="row">
        <div class="col-12">
          <div class="table-responsive-sm">
            <table class="table table-sm table-border">
              <thead class="table-light">
                <tr>
                  <td style="width: 15%;">
                    Job Date
                  </td>
                  <td style="width: 15%;">
                    Payroll Due Date
                  </td>
                  <td style="width: 10%;">
                    SO#
                  </td>
                  <td style="width: 20%;">
                    Labor Name
                  </td>
                  <td style="width: 15%;">
                    Request Date
                  </td>
                  <td style="width: 15%;">
                    Approved Date
                  </td>
                  <td style="width: 10%;">
                    Status
                  </td>
                </tr>
              </thead>
              <tbody>
                @for (row of cmPayrollCorrectionRequestApprovedList; track row) {
                <tr>
                  <td>
                    {{row.jobDate | date:DAY_NAME_MONTH_DAY_YEAR}}
                  </td>
                  <td>
                    {{row.payrollDueDate | date:DAY_NAME_MONTH_DAY_YEAR}}
                  </td>
                  <td>
                    @if (row.isUnbillHrs) {
                    <div>
                      Unbilled
                    </div>
                    }
                    @if (!row.isUnbillHrs) {
                    <div>
                      {{row.serviceOrderFullNumber}}
                    </div>
                    }
                  </td>
                  <td>
                    {{row.laborName}}
                  </td>
                  <td>
                    {{row.payrollCorrectionRequestDate | date:DAY_NAME_MONTH_DAY_YEAR_AM_PM}}
                  </td>
                  <td>
                    {{row.payrollCorrectionApprovedDate | date:DAY_NAME_MONTH_DAY_YEAR_AM_PM}}
                  </td>
                  <td>
                    @if (!row.isPayrollCorrectionApproved) {
                    <div class="warning-color">
                      Pending
                    </div>
                    }
                    @if (row.isPayrollCorrectionApproved) {
                    <div class="success-color">
                      Approved
                    </div>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      }
    </div>
  </tui-loader>
</ng-template>